import {React, useState} from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RequestQuote from "../components/RequestQuote";
import Quoteimg from "../assets/img/qouteelementor.png"; 
import amlInsight from "../assets/img/amlInsight.jpeg";
import { NavLink } from "react-router-dom"; 
import amlnew from "../assets/img/amlnew.jpeg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faTasks,
  faTachometerAlt,
} from "@fortawesome/free-solid-svg-icons";
import RFQModal from "../components/RFQModal";
import fraud from "../assets/img/fraud.jpeg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
const AmlInsight = () => {

    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);
  return (
    <div>
      <Navbar />
      {/* Hero Section */}
      <div className="case_title_container_aml">
        <main>
          <div className="bps-intr-contnt">
            <h1>
            AML Solutions by Outcess
            </h1>
            <button className="ccsnl-btn cld-rfq-lg" onClick={handleShow}>
                Request for Consultation
              </button>
          </div>
          <RFQModal show={show} setShow={setShow} />
        </main>
      </div>
      {/* Background Section */}
      <section className="background">
        <main>
          <div className="container">
            <h2>Service Overview</h2>
            <h4>
            Outcess AML Solutions is an AI-powered fraud detection and anti-money laundering (AML) 
            compliance platform designed to help businesses safeguard their financial operations. 
            With advanced observability, real-time analytics, and adaptive machine learning models, 
            our solution empowers organizations to detect, prevent, and respond to financial crimes 
            before they cause irreversible damage.
            </h4>
            <button className="ccsnl-btn" onClick={handleShow}>
              Request for Consultation
            </button>
          </div>
        </main>
      </section>

      {/* Challenge Section */}
      <section className="challenge">
        <main>
          <div className="container">
            <h2>How It Works</h2>
            <p className="mb-4">
            AML Insight leverages cutting-edge AI and data analytics to offer a comprehensive fraud detection 
            and compliance framework. The process includes:
            </p>
            <div className="challenge-details">
              <div className="challenge-text">
                <ul>
                  <li>
                    <strong>1. Data Ingestion & Monitoring:</strong> AML Insight integrates seamlessly with banking, payment,
                     and financial systems to monitor transactions in real-time.
                  </li>
                  <li>
                    <strong>2. Anomaly Detection:</strong>  AI-powered models analyze transaction patterns and flag suspicious activities,
                     minimizing false positives.
                  </li>
                  <li>
                    <strong>3. Behavioral Analysis:</strong> By studying user behavior, AML Insight identifies unusual account activities and 
                     potential fraud attempts
                  </li>
                  <li>
                    <strong>4. Automated Risk Scoring:</strong> Every transaction is assigned a risk score, helping compliance teams prioritize
                      investigations efficiently.
                  </li>
                  <li>
                   <strong>5. Regulatory Compliance:</strong> Ensures businesses adhere to AML and KYC regulations by automating identity verification
                     and suspicious activity reporting.
                   </li>
                   <li>
                    <strong>6. Adaptive Learning:</strong> The system continuously refines its algorithms based on new fraud patterns,
                      ensuring proactive threat detection.
                   </li>
                </ul>
              </div>
              <div className="challenge-image" >
                    <img src={fraud} alt="Quote img"  className="challenge-details"/>
                     </div>
            </div>
          </div>
        </main>
      </section>

              {/* Our Services Offered */}
              <section className="custodian-approach-section">
  <main>
    <h2 className="custodian-section-title">Services Offered</h2>
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      spaceBetween={20}
      slidesPerView={3}
      navigation
      pagination={{ clickable: true }}
      autoplay={{ delay: 3000 }}
      breakpoints={{
        320: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      }}
    >
      {/* Fraud Detection & Prevention */}
      <SwiperSlide>
        <div className="biz-sol-card" data-aos="fade-up" data-aos-delay="100">
          <span>
            <FontAwesomeIcon icon={faTachometerAlt} size="3x" />
          </span>
          <h3 className="custodian-approach-title">Fraud Detection & Prevention</h3>
          <ul className="custodian-challenges-list">
            <li className="mb-3"><span className="custodian-challenge-text">Real-time transaction monitoring</span></li>
            <li className="mb-3"><span className="custodian-challenge-text">AI-powered fraud risk assessment</span></li>
            <li><span className="custodian-challenge-text">Suspicious activity detection and alerts</span></li>
          </ul>
        </div>
      </SwiperSlide>

      {/* Anti-Money Laundering (AML) Compliance */}
      <SwiperSlide>
        <div className="biz-sol-card" data-aos="fade-up" data-aos-delay="400">
          <span>
            <FontAwesomeIcon icon={faChartLine} size="3x" />
          </span>
          <h3 className="custodian-approach-title">Anti-Money Laundering (AML) Compliance</h3>
          <ul className="custodian-challenges-list">
            <li className="mb-3"><span className="custodian-challenge-text">Automated Know Your Customer (KYC) verification</span></li>
            <li className="mb-3"><span className="custodian-challenge-text">Risk-based transaction screening</span></li>
            <li><span className="custodian-challenge-text">Suspicious Activity Reports (SARs) filing automation</span></li>
          </ul>
        </div>
      </SwiperSlide>

      {/* Observability & Risk Intelligence */}
      <SwiperSlide>
        <div className="biz-sol-card" data-aos="fade-up" data-aos-delay="700">
          <span>
            <FontAwesomeIcon icon={faTasks} size="3x" />
          </span>
          <h3 className="custodian-approach-title">Observability & Risk Intelligence</h3>
          <ul className="custodian-challenges-list">
            <li className="mb-3"><span className="custodian-challenge-text">Advanced data analytics dashboard</span></li>
            <li className="mb-3"><span className="custodian-challenge-text">Customizable reporting and insights</span></li>
            <li><span className="custodian-challenge-text">Integration with existing compliance workflows</span></li>
          </ul>
        </div>
      </SwiperSlide>

      {/* AI-Driven Threat Intelligence */}
      <SwiperSlide>
        <div className="biz-sol-card" data-aos="fade-up" data-aos-delay="700">
          <span>
            <FontAwesomeIcon icon={faTasks} size="3x" />
          </span>
          <h3 className="custodian-approach-title">AI-Driven Threat Intelligence</h3>
          <ul className="custodian-challenges-list">
            <li className="mb-3"><span className="custodian-challenge-text">Machine learning models for continuous fraud pattern recognition</span></li>
            <li className="mb-3"><span className="custodian-challenge-text">Adaptive algorithms to minimize false positives and negatives</span></li>
            <li><span className="custodian-challenge-text">AI-driven predictive risk analysis</span></li>
          </ul>
        </div>
      </SwiperSlide>
    </Swiper>
  </main>
</section>

        
      <section>
        <main>
          <div className="request_quote_container">
            <img src={Quoteimg} alt="Quote img" className="Quoteimg" />

            <div>
              <RequestQuote />
            </div>
          </div>
        </main>
      </section>
      <Footer />
    </div>
  );
};

export default AmlInsight;
